<template>
  <table class="deal-table">
    <thead>
      <tr>
        <th class="text-align-left">
          {{ __('Usuário') }}
        </th>
        <th>{{ __('Negócios') }}</th>
        <th>{{ __('Valor dos negócios') }}</th>
        <th>{{ __('Valor médio dos negócios') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="user in list">
        <td class="text-align-left">
          {{ name(user.id) }}
        </td>
        <td>{{ user.count || 0 | number(0) }}</td>
        <td>{{ user.total || 0 | currency(0) }}</td>
        <td>{{ user.total / user.count || 0 | currency }}</td>
      </tr>
      <tr v-if="list.length > 1">
        <td class="text-align-left">
          Todos
        </td>
        <td>{{ count || 0 | number(0) }}</td>
        <td>{{ total || 0 | currency(0) }}</td>
        <td>{{ total / count || 0 | currency }}</td>
      </tr>
      <tr v-if="list.length > 1">
        <td class="text-align-left">
          {{ __('Média') }}
        </td>
        <td>{{ averageCount || 0 | number }}</td>
        <td>{{ averageTotal || 0 | currency }}</td>
        <td>{{ averageTotal / averageCount || 0 | currency }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ['list', 'users'],

  mounted () {
    this.stats();
  },

  data () {
    return {
      count: 0,
      total: 0,
      averageCount: 0,
      averageTotal: 0,
    };
  },

  methods: {
    name (id) {
      return this.users[id].name;
    },

    stats () {
      this.list.forEach((element) => {
        this.count += element.count;
        this.total += element.total;
      });

      if (this.list.length) {
        this.averageCount = this.count / this.list.length;
        this.averageTotal = this.total / this.list.length;
      }
    },
  },
};
</script>
